import './style.scss'
import { message, Popover, Tooltip } from 'antd'
import { FC, memo, useMemo, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'
import TemplateModal from '@/components/TemplateModal'
import { UserStore } from '@/global-states'
import { CopyOutlined, EyeInvisibleOutlined, EyeOutlined, InfoCircleOutlined } from '@ant-design/icons'

const VipAgent: FC = () => {
  const { t: translate } = useTranslation(['personal', 'system'])
  const { userPackage } = UserStore
  const [viewAgent, setViewAgent] = useState(false)
  const [templateModalOpen, setTemplateModalOpen] = useState(false)
  const showAgent = useMemo(() => {
    const id = userPackage?.hifly_id
    if (viewAgent) {
      return id
    }
    return id?.replace(/./g, '*')
  }, [userPackage?.hifly_id, viewAgent])

  if (!showAgent) return null

  return (
    <div className="vip-agent">
      <div className="title">
        {translate('personal.agent_info')}
        <Popover
          content={
            <div className="point-popover" style={{ width: '340px' }}>
              {translate('personal.agent_description')}
              <a
                target="_blank"
                href="https://www.coze.cn/store/plugin/7472321639192084506"
                className="gradient"
                rel="noreferrer"
              >
                {translate('personal.view_on_coze')}
              </a>
            </div>
          }
          placement="right"
        >
          <InfoCircleOutlined />
        </Popover>
        <span className="gradient" onClick={() => setTemplateModalOpen(true)}>
          查看模板
        </span>
      </div>
      <div className="agent-detail">
        <div className="label">hifly_agent_token：</div>
        <div className="agent">{showAgent}</div>
        <Tooltip placement="top" title={translate('system.copy')}>
          <CopyToClipboard
            text={userPackage?.hifly_id || ''}
            onCopy={() => {
              message.success(translate('system.copied'))
            }}
          >
            <CopyOutlined />
          </CopyToClipboard>
        </Tooltip>

        <div className="icon" onClick={() => setViewAgent(!viewAgent)}>
          {!viewAgent ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        </div>
      </div>

      <TemplateModal open={templateModalOpen} onCancel={() => setTemplateModalOpen(false)} />
    </div>
  )
}

export default memo(VipAgent)
